package cbconnectit.portfolio.web.styles

import org.jetbrains.compose.web.css.px

/**
 * Reusable table styling constants
 */
object TableStyles {
    // Padding
    val headerPaddingLeftRight = 16.px
    val headerPaddingTopBottom = 12.px
    val cellPaddingLeftRight = 16.px
    val cellPaddingTopBottom = 10.px
    val expandedContentPadding = 24.px

    // Border
    val borderWidth = 1.px
    val borderRadius = 16.px

    // Sizes
    val minColumnWidth = 60.px
    val emptyStateHeight = 120.px
}

